<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/projects/` : "/api/projects/"
const { data } = await useFetch(apiUrl, { key: "projects-page" })

const page = computed(() => data.value?.page || {})
const projects = computed(() => (data.value?.items?.length ? data.value.items : []))
const title = computed(() => page.value.title || "Проєкти")
const subtitle = computed(() => page.value.subtitle || "")
const seoTitle = computed(() => page.value.seo_title || title.value)
const seoDescription = computed(() => page.value.seo_description || subtitle.value)
const breadcrumbs = computed(() => [
  { label: "Головна", to: "/" },
  { label: title.value },
])

useSeoMeta({
  title: () => seoTitle.value,
  description: () => seoDescription.value,
  ogTitle: () => seoTitle.value,
  ogDescription: () => seoDescription.value,
  twitterTitle: () => seoTitle.value,
  twitterDescription: () => seoDescription.value,
})
</script>

<template>
  <section class="section-projects projects-page">
    <div class="projects-page__hero">
      <Breadcrumbs :items="breadcrumbs" />
      <h1 class="projects-page__title">{{ title }}</h1>
      <div v-if="subtitle" class="projects-page__subtitle" v-html="subtitle"></div>
    </div>

    <div v-if="projects.length" class="projects-grid projects-page__grid">
      <ProjectCard
        v-for="(project, index) in projects"
        :key="project.slug"
        :project="project"
        class="projects-page__card"
        :style="{ '--card-delay': `${Math.min(index, 8) * 90}ms` }"
      />
    </div>
    <p v-else class="projects-page__empty">Проєкти скоро зʼявляться.</p>
  </section>
</template>

<style lang="scss" scoped>
@use "/assets/scss/sections/_projects.scss";

.projects-page {
  padding-top: 3.5em;
}

.projects-page__hero {
  display: flex;
  flex-direction: column;
  gap: 1em;
  max-width: 48em;
}

.projects-page__title {
  font-size: clamp(2.25rem, 5vw, 4.5rem);
  line-height: 1.08;
}

.projects-page__subtitle {
  color: #555;
  font-size: 1.1em;
  line-height: 1.65;
}

.projects-page__empty {
  color: #555;
  font-size: 1.1em;
}

.projects-page__card {
  animation: project-card-in 0.75s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: var(--card-delay, 0ms);
  transform-origin: center bottom;
}

@keyframes project-card-in {
  from {
    opacity: 0;
    transform: translate3d(0, 1.8em, 0) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .projects-page__card {
    animation: none;
  }
}
</style>
